import React from 'react';
import styled from 'styled-components';

interface CircularProgressProps {
  progress: number; // 0-100
  size?: number;
  strokeWidth?: number;
  color?: string;
  backgroundColor?: string;
  showText?: boolean;
  currentCount?: number;
  totalCount?: number;
  textColor?: string;
}

const CircularProgress: React.FC<CircularProgressProps> = ({
  progress,
  size = 24,
  strokeWidth = 3,
  color = '#FFFFFF',
  backgroundColor = '#FFFFFF33',
  showText = false,
  currentCount,
  textColor = '#FFFFFF'
}) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const offset = circumference - (progress / 100) * circumference;

  return (
    <CircularProgressContainer size={size}>
      <svg width={size} height={size}>
        {/* Background circle */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={backgroundColor}
          strokeWidth={strokeWidth}
        />
        {/* Progress circle */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
          style={{ transition: 'stroke-dashoffset 0.3s ease' }}
        />
      </svg>
      {showText && currentCount !== undefined && (
        <ProgressText color={textColor}>
          {currentCount}
        </ProgressText>
      )}
    </CircularProgressContainer>
  );
};

const CircularProgressContainer = styled.div<{ size: number }>`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${props => props.size}px;
  height: ${props => props.size}px;
`;

const ProgressText = styled.span<{ color: string }>`
  position: absolute;
  font-size: 10px;
  font-weight: 600;
  color: ${props => props.color};
  user-select: none;
`;

export default CircularProgress;
